import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import ServerResponesToast from "./ServerResponseToast";
import toastHelper from "./ToastHelper";

const ToastContext = createContext(null);

// export const useToast = () => useContext(ToastContext);

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return ctx;
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    open: false,
    success: false,
    message: "",
  });

  const showToast = useCallback((success, message) => {
    setToast({ open: true, success, message });
  }, []);

  useEffect(() => {
    toastHelper.register(showToast);
  }, [showToast]);

  const handleClose = () => setToast((prev) => ({ ...prev, open: false }));

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ServerResponesToast
        open={toast.open}
        success={toast.success}
        message={toast.message}
        onClose={handleClose}
      />
    </ToastContext.Provider>
  );
};

export default ToastProvider;
